import { render } from "./VotesTable.vue?vue&type=template&id=fe8d7f94"
import script from "./VotesTable.vue?vue&type=script&lang=js"
export * from "./VotesTable.vue?vue&type=script&lang=js"

import "./VotesTable.vue?vue&type=style&index=0&id=fe8d7f94&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__